import { CommandParser } from '../client/parser';
import { RedisArgument, MapReply, BlobStringReply, Command } from '../RESP/types';
import { transformTuplesReply } from './generic-transformers';

export default {
  parseCommand(parser: CommandParser, key: RedisArgument) {
    parser.push('HGETALL');
    parser.pushKey(key);
  },
  TRANSFORM_LEGACY_REPLY: true,
  transformReply: {
    2: transformTuplesReply<BlobStringReply>,
    3: undefined as unknown as () => MapReply<BlobStringReply, BlobStringReply>
  }
} as const satisfies Command;
